import './header-menu-core.js';

/*
 * BGShopping desktop mega-menu hover guard.
 * Keep the native Shopify menu logic, but do not let a desktop submenu
 * disappear while the pointer is travelling from the top-level item into it.
 * Touch/mobile and keyboard focus keep Shopify's native behaviour.
 */
const HeaderMenu = customElements.get('header-menu');

if (HeaderMenu && !HeaderMenu.prototype.__bgshoppingHoverGuard) {
  const nativeDeactivate = HeaderMenu.prototype.deactivate;
  const closeTimers = new WeakMap();
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  const clearCloseTimer = (menu) => {
    const timer = closeTimers.get(menu);
    if (timer) clearTimeout(timer);
    closeTimers.delete(menu);
  };

  const pointerStillInsideMenu = (menu) => {
    if (!menu || !menu.isConnected) return false;

    if (menu.matches(':hover')) return true;
    if (menu.querySelector('.menu-list__list-item:hover, .menu-list__submenu:hover')) return true;

    const overflow = menu.refs?.overflowMenu?.shadowRoot?.querySelector('[part="overflow"]');
    if (overflow?.matches(':hover')) return true;

    return false;
  };

  const scheduleClose = (menu, event, firstDelay = 650) => {
    clearCloseTimer(menu);

    const check = () => {
      if (pointerStillInsideMenu(menu)) {
        closeTimers.set(menu, setTimeout(check, 160));
        return;
      }

      closeTimers.delete(menu);
      nativeDeactivate.call(menu, event);
    };

    closeTimers.set(menu, setTimeout(check, firstDelay));
  };

  HeaderMenu.prototype.deactivate = function bgshoppingDeactivate(event) {
    const isDesktopPointerLeave =
      finePointer.matches &&
      event &&
      event.type === 'pointerleave' &&
      event.target instanceof Element;

    if (!isDesktopPointerLeave) {
      clearCloseTimer(this);
      return nativeDeactivate.call(this, event);
    }

    scheduleClose(this, event);
  };

  document.addEventListener(
    'pointerenter',
    (event) => {
      if (!finePointer.matches || !(event.target instanceof Element)) return;
      const menu = event.target.closest('header-menu');
      if (menu) clearCloseTimer(menu);
    },
    true
  );

  HeaderMenu.prototype.__bgshoppingHoverGuard = true;
}

/*
 * BGShopping desktop mega-menu top-edge fix.
 * In the two-row header, Shopify's calculated clip/translate can hide the
 * first menu item. Keep the native open/close logic, but anchor the dropdown
 * directly below the menu row and remove only the visual clipping on desktop.
 */
if (!document.getElementById('bgshopping-mega-menu-top-fix')) {
  const style = document.createElement('style');
  style.id = 'bgshopping-mega-menu-top-fix';
  style.textContent = `
    @media screen and (min-width: 750px) {
      #header-component .menu-list__list-item:not([slot='overflow']) > .menu-list__submenu {
        top: 100% !important;
        clip-path: none !important;
      }

      #header-component .menu-list__list-item:not([slot='overflow']) > .menu-list__submenu .menu-list__submenu-inner {
        transform: none !important;
      }

      #header-component .menu-list__list-item.bg-categories-offset > .menu-list__submenu {
        top: calc(100% + 72px) !important;
      }

      #header-component .menu-list__list-item.bg-categories-offset > .menu-list__submenu::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: -72px;
        height: 72px;
      }
    }
  `;
  document.head.appendChild(style);
}

/* Move only the top-level Категории mega menu two steps lower on desktop. */
const markCategoriesOffset = () => {
  document
    .querySelectorAll('#header-component .menu-list__list-item:not([slot="overflow"])')
    .forEach((item) => {
      const directLink = item.querySelector(':scope > .menu-list__link');
      const title = directLink?.querySelector('.menu-list__link-title')?.textContent?.trim() || '';

      if (title.includes('Категории')) {
        item.classList.add('bg-categories-offset');
      }
    });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', markCategoriesOffset, { once: true });
} else {
  markCategoriesOffset();
}
